import React from 'react';
import ScrollToTopComponent from 'react-scroll-up';

import './ScrollToTop.module.css';

import ToTopIcon from 'Images/arrow_left.png';

function ScrollToTop() {
  return (
    <ScrollToTopComponent
      showUnder={300}
      duration={500}
      style={{
        position: 'fixed',
        bottom: 30,
        right: 30,
        cursor: 'pointer',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'linear',
        transitionDelay: '0s',
      }}
    >
      <div styleName="ScrollToTop">
        <img src={ToTopIcon} />
      </div>
    </ScrollToTopComponent>
  );
}

export default ScrollToTop;



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.js